module.exports = {
  getWorkouts: function (userId, limit, orderBy) {
    return this.client.get(`/v${this.v}/workout/`, {
      params: {
        user: userId,
        limit: limit,
        order_by: orderBy,
      },
    })
  },

  putWorkout: function (data, id, config) {
    return this.client.put(`/v${this.v}/workout/${id}/`, data, config)
  },

  postWorkout: function (data, config) {
    return this.client.post(`/v${this.v}/workout/`, data, config)
  },

  getCalories: function (data) {
    const options = {
      baseURL: '/_api',
      params: {
        activity_type: data.activityType,
        pace: data.pace,
        speed_unit: data.speedUnit,
        pace_unit: data.paceUnit,
        distance: data.distance,
        duration: data.duration,
      },
    }

    return this.client.get('/workout/calculate/calories/', options)
  },

  getWorkoutById: function (workoutId, config) {
    return this.client.get(`/v${this.v}/workout/${workoutId}/`, config)
  },

}
